<template>
  <!-- 出行人列表 选择出行人 -->
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      class="full-height full-width bg-gray"
      :close-on-click-overlay="false"
      :close-on-popstate="true"
      :get-container="getContainer"
      safe-area-inset-bottom
    >
      <div class="traverList12306">
        <ld-header
          @click-left="toggle"
          @click-right="getList"
        >
          {{ $t('B063','选择') }}{{ $t('Q510','乘客') }}
          <template v-slot:right>
            <van-icon
              name="replay"
              size="20"
            />
          </template>
        </ld-header>

        <div class="traverList12306-wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
          >
            <div class="traverList12306-content">
              <van-row
                v-if="tripType == 2"
                class="pad8"
              >
                <van-row class="round-sm mt5 pad8 orange bg-lightYellow font12">
                  <b class="font14">出差申请</b> 模式下，只展示12306常旅客中与出差人员姓名一致的常旅客。
                </van-row>
              </van-row>
              <van-row
                v-if="filterPsgList.length > 0"
                class="pad8"
              >
                <van-row class="round-sm pad8 orange bg-lightYellow font12">
                  根据有关部门要求，为加强疫情防控，乘客须补齐证件信息、联系方式并完成核验。
                </van-row>
              </van-row>

              <van-row class="pad8">
                <ld-button
                  light
                  icon="add-o"
                  @click="handleAddPsg"
                >
                  新增乘客
                </ld-button>
              </van-row>

              <van-row class="mt5 traverList12306-item">
                <van-cell
                  v-for="psg in filterPsgList"
                  :key="psg.id"
                  center
                  @click="handleCheckedPsg(psg)"
                >
                  <template #icon>
                    <van-icon
                      name="edit"
                      size="24"
                      class="main-color icon-edit"
                      @click.stop="handleEditPsg(psg)"
                    />
                  </template>

                  <template #right-icon>
                    <van-checkbox
                      v-if="psg.checkStatus == 1 || psg.phoneCheckStatus == 1"
                      name="certificate"
                      class="icon-checked"
                      disabled
                    />
                    <van-checkbox
                      v-else
                      v-model="psg.checked"
                      name="certificate"
                      class="icon-checked"
                    />
                  </template>

                  <template #title>
                    <span class="font16">{{ psg.name }}</span>&nbsp;
                    <van-tag
                      plain
                      class="psgType vertical-bottom"
                    >
                      {{ psg.personType | passengerType }}
                    </van-tag>
                  </template>

                  <template #label>
                    <span
                      v-if="!psg.phone"
                      class="red"
                    >
                      根据铁路局最新规定，请补全乘客手机号码
                    </span>
                    <span
                      v-else-if="psg.checkStatus == 1 || psg.phoneCheckStatus == 1"
                      class="red"
                    >
                      <span v-if="psg.checkStatus == 1">身份待核验</span>&nbsp;
                      <span v-if="psg.phoneCheckStatus == 1">联系方式待核验</span>
                    </span>
                    <span
                      v-else
                      class="gray"
                    >
                      {{ psg.identyType | idType }} &nbsp; {{ psg.identy }}
                    </span>
                  </template>

                  <img
                    v-if="psg.checkStatus == 1"
                    width="22"
                    src="~Assets/images/tr/user-verification-error.png"
                  >
                  <img
                    v-else
                    width="22"
                    src="~Assets/images/tr/user-verification-success.png"
                  >
                  &nbsp;
                  <img
                    v-if="psg.phoneCheckStatus == 1"
                    width="22"
                    src="~Assets/images/tr/mobile-verification-error.png"
                  >
                  <img
                    v-else
                    width="22"
                    src="~Assets/images/tr/mobile-verification-success.png"
                  >
                  <!-- <span
                    v-if="psg.passed"
                    class="green"
                  >
                    已通过
                  </span> -->
                </van-cell>
              </van-row>
            </div>

            <div
              v-if="filterPsgList.length == 0"
              class="traverList12306-content"
            >
              <van-row class="pad8">
                <van-row class="round-sm mt5 pad8 bg-lightYellow font12 text-center">
                  12306乘客没有变化 ？
                  <span
                    class="main-color"
                    @click="getList"
                  >刷新试试</span>
                </van-row>
              </van-row>

              <van-empty
                image="search"
                description="您还没添加过乘客信息哦~"
              >
                <ld-button
                  @click="handleAddPsg"
                  main2
                  size="sm"
                >
                  去添加乘客
                </ld-button>
              </van-empty>
            </div>
          </mescroll-vue>
        </div>

        <!-- 底部 -->
        <ld-tabbar
          v-if="filterPsgList.length > 0"
          class="tabbar shadow"
        >
          <ld-button
            @click="complie"
            main3
            size="lg"
          >
            {{ $t('B006', '确定') }}
          </ld-button>
        </ld-tabbar>
      </div>
    </van-popup>

    <edit-psg
      ref="editPsg"
      @selected="handleConfirmPsg"
      :element="element"
    />
    <verificate
      ref="verificate"
      verificationnew="traverList"
      @success="success"
      :element="element"
    />
    <!-- :element="element"
  
      :sms-check-msg="smsCheckMsg" -->
  </div>
</template>

<script >
import { Popup, CellGroup, Cell, Search, Tab, Tabs, Tag, Button, Checkbox } from 'vant'
import { mapGetters } from 'vuex'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import editPsg, { PSG_TYPE, CARD_TYPE } from './editPsg.vue'
import verificate from 'Views/Tr/trQuery/trEdit/verificate12306.vue'
export default {
  name: 'TraverList12306',
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Search.name]: Search,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldTabbar,
    editPsg,
    ldButton,
    verificate
  },
  props: {
    personList: {//从外部传入员工列表  例如申请单传入
      type: Array,
      default: () => []
    },
    element: {
      type:String,
      default:''
    },
  },
  data() {
    return {
      down: { use: false },
      isShow: false,
      psgInfo: {},
    }
  },
  computed: {
    ...mapGetters({
      tripType: 'tripType',
      travelerList: 'tr/travelerList',
      trSearchInfo: 'tr/trSearchInfo',
    }),
    filterPsgList () {
      /**
       * 传入了 出差申请单上的出行人
       * 只展示12306常旅客中与出差申请单上姓名+证件号一致的人
       */
      if (this.personList.length > 0) {
        return this.trSearchInfo['12306Info'].psgList.filter(psg => {
          return this.personList.find(person => person.cxrName == psg.name)
        })
      }

      return this.trSearchInfo['12306Info'].psgList
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 完成
    complie() {
      this.$emit('selected', this.trSearchInfo['12306Info'].psgList.filter(psg => psg.checked && (psg.checkStatus != 1 && psg.phoneCheckStatus != 1)))
      this.toggle()
    },
    async getList() {
      this.$store.dispatch('tr/getAccountPsgList').then(() => {
      }).catch((err) => {
        if (err.errCode == '239001' || err.errCode == '239003') {
          this.$dialog.alert({
            title: '温馨提示',
            message: '根据铁路局规定，你的账号需要先完成短信核验。',
            confirmButtonText: '去核验',
          }).then(async () => {
            this.$refs['verificate'].toggle()
          })
        }
      })
    },
    // 登录成功
    success(verificateCode) {
      this.show = false
      verificateCode ? this.trSearchInfo['12306Info'].verificateCode = verificateCode : ''
      this.$store.dispatch('tr/getAccountPsgList')
    },
    handleAddPsg () {
      this.$refs.editPsg.toggle({})
    },
    handleEditPsg (psg) {
      this.$refs.editPsg.toggle(psg)
    },
    handleCheckedPsg (psg) {
      if (!psg.phone) {
        this.handleEditPsg(psg)
      } else {
        this.$set(psg, 'checked', !psg.checked)
      }
    },
    handleConfirmPsg (psg) {
      this.getList()
    },
    toggle () {
      this.isShow = !this.isShow
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    }
  },
  filters: {
    passengerType (val) {
      let type = PSG_TYPE.find(type => type.key == val)
      return type ? type.name : ''
    },
    idType (val) {
      let type = CARD_TYPE.find(type => type.key == val)
      return type ? type.name : ''
    },
  }
}
</script>

<style lang="less" scoped>
.traverList12306 {
  .mt5 {
    margin-top: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  &-wrapper {
    margin-top: 4px;
    height: calc(100vh - 110px);
    overflow: hidden;
  }

  &-content {
    background-color: @color-background-white;
  }

  &-item {
    .icon-edit {
      margin-right: 12px;
    }

    .van-cell__title {
      flex: 2;
    }

    .psgType {
      font-size: 10px;
    }

    .van-cell {
      padding: 16px;
      line-height: 16px;
    }

    .van-cell__label {
      font-size: 11px;
    }

    .icon-checked {
      margin-left: 12px;
    }
  }

  .tabbar {
    padding: 8px;
    height: auto;
  }
}
</style>
